/**
 * Enum representing the names of terms and conditions services.
 * @enum {string}
 */
enum TermsAndConditionsServiceNames {
    /**
     * Name of the service for ClinicAid terms and conditions.
     * @type {string}
     */
    ClinicAid = "ClinicAidTermsAndConditions"
}

export { TermsAndConditionsServiceNames };
